<h4 class="tds-u-pl1" >Add user</h4>
<div class="tds-row tds-u-mb1">
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" style="padding-bottom: 7px;">
        <tds-text-field
            [(ngModel)]="globalId"
            size="md"
            ngDefaultControl
            label="Enter Global ID"
            label-position="inside">
        </tds-text-field>
    </div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" style="padding-bottom: 7px;">
        <tds-text-field
            [(ngModel)]="email"
            size="md"
            ngDefaultControl
            label="Enter Email"
            label-position="inside">
        </tds-text-field>
    </div>
        
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" style="padding-bottom: 7px;">
        <tds-text-field
            [(ngModel)]="firstName"
            size="md"
            ngDefaultControl
            label="Enter First Name"
            label-position="inside">
        </tds-text-field>
    </div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" style="padding-bottom: 7px;">
        <tds-text-field
            [(ngModel)]="lastName"
            size="md"
            ngDefaultControl
            label="Enter Last Name"
            label-position="inside">
        </tds-text-field>
    </div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" style="padding-bottom: 7px;">
        <tds-text-field
            [(ngModel)]="department"
            size="md"
            ngDefaultControl
            label="Enter Department"
            label-position="inside">
        </tds-text-field>
    </div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" style="padding-bottom: 7px;">
        <tds-dropdown
            ngDefaultControl
            name="dropdown"
            label="Select Role"
            label-position="inside"
            size="md"
            default-value="Beställare"
            open-direction="auto">
            <tds-dropdown-option (click)="role='Beställare'" value="Beställare">Beställare</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Chef'" value="Chef">Chef</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Chef tillförordnad'" value="Chef tillförordnad">Chef tillförordnad</tds-dropdown-option>
            <tds-dropdown-option (click)="role='HRBP'" value="HRBP">HRBP</tds-dropdown-option>
            <tds-dropdown-option (click)="role='HRM'" value="HRM">HRM</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Medarbetare'" value="Medarbetare">Medarbetare</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Beställare'" value="Beställare">Beställare</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Std HRAdmin'" value="Std HRAdmin">Std HRAdmin</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Exec comp HRBP'" value="Exec comp HRBP">Exec comp HRBP</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Exec comp Manager'" value="Exec comp Manager">Exec comp Manager</tds-dropdown-option>
            <tds-dropdown-option (click)="role='HR administratör'" value="HR administratör">HR administratör</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Löneadministratör'" value="Löneadministratör">Löneadministratör</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Rekryteringsspecialist'" value="Rekryteringsspecialist">Rekryteringsspecialist</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Resax'" value="Resax">Resax</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Timeadmin'" value="Timeadmin">Timeadmin</tds-dropdown-option>
            <tds-dropdown-option (click)="role='HR Generalist'" value="HR Generalist">HR Generalist</tds-dropdown-option>
            <tds-dropdown-option (click)="role='Lönebildning/Statistik'" value="Lönebildning/Statistik">Lönebildning/Statistik</tds-dropdown-option>
        </tds-dropdown>
    </div>
</div>

<div class="tds-u-ml2">
    <tds-button type="submit" variant="primary" size="lg" [disabled]="!isValuesSet()" text="Submit" (click)="addRole()">
        <tds-icon slot="icon" class="tds-btn-icon" size="20px" name="send"></tds-icon>
    </tds-button>
</div>

<h4 class="tds-u-pl1" *ngIf="roles.length > 0">
    Current manually added users
</h4>

<div *ngIf="roles.length > 0">
  <tds-table vertical-dividers="false" compact-design="true" responsive="true" no-min-width>
        <tds-table-header>
            <tds-header-cell cell-key="globalId" cell-value="Global Id" custom-width="50px"></tds-header-cell>
            <tds-header-cell cell-key="email"cell-value="Email" ></tds-header-cell>
            <tds-header-cell cell-key="name" cell-value="Name"></tds-header-cell>
            <tds-header-cell cell-key="dep" cell-value="Department"custom-width="30px"></tds-header-cell>
            <tds-header-cell cell-key="role" cell-value="Role" custom-width="30px"></tds-header-cell>
            <tds-header-cell cell-key="remove" cell-value="Remove" text-align="right"></tds-header-cell>
        </tds-table-header>
        <tds-table-body>
            <tds-table-body-row *ngFor="let role of roles">
                <tds-body-cell cell-key="globalId" disable-padding="true">
                    <div class="tds-u-pt3">
                        {{ role.globalId }}
                    </div>
                </tds-body-cell>
                <tds-body-cell cell-key="email">
                    <div class="tds-u-pt3" style="white-space: nowrap;">
                        {{ role.email }}
                    </div>
                </tds-body-cell>
                <tds-body-cell cell-key="name">
                    <div  class="tds-u-pt3">
                        {{ role.name }}
                    </div>
                </tds-body-cell>
                <tds-body-cell cell-key="dep">
                    <div style="width:30px" class="tds-u-pt3">
                        {{ role.department }}
                    </div>
                </tds-body-cell>
                <tds-body-cell cell-key="role">
                    <div class="tds-u-pt3">
                        {{ role.role }}
                    </div>
                </tds-body-cell>
                <tds-body-cell cell-key="remove">
                    <div style="width:30px">
                        <tds-button type="button" variant="danger" size="sm" text="" (click)="removeRole(role.globalId)">
                            <tds-icon slot="icon" class="tds-btn-icon" size="16px" name="trash"></tds-icon>
                        </tds-button>
                    </div>
                </tds-body-cell>
            </tds-table-body-row>
        </tds-table-body>
    </tds-table>
</div>